import _ from 'lodash';
import React, { useState } from 'react';
import ReactJson from '@uiw/react-json-view';
import { TextArea } from 'semantic-ui-react';

const JsonPasteSettings = (props) => {

  const { handlePreviewReady } = props

  const [pasteValue, setPasteValue] = useState()
  const [settings, setSettings] = useState()

  const handlePasteChange = (e, data) => {
    const jp = data.value
    setPasteValue(jp)
    if (jp) {
      try {
        const jpp = JSON.parse(jp)
        const _settings = {
          global: jpp.aps_global,
          viewItems: jpp.aps_viewItems,
          views: jpp.aps_views,
        }
        handlePreviewReady(_settings)
        setSettings(_settings)
      } catch (error) {
        handlePreviewReady({})
      }
    }
  }

  const jsonPaste = () => <TextArea onChange={handlePasteChange} style={{ height: '100%', width: '100%' }} />

  const viewer = () => {
    return <ReactJson
      name={_.startCase('Results')}
      collapsed={true}
      displayDataTypes={false}
      enableClipboard={false}
      sortKeys={true}
      theme="monokai"
      displayObjectSize={false}
      enableAdd={true}
      src={settings}
    />

    // return <ReactJson
    //   name={_.startCase('Results')}
    //   collapsed={true}
    //   displayDataTypes={false}
    //   enableClipboard={false}
    //   sortKeys={true}
    //   theme={'monokai'}
    //   displayObjectSize={false}
    //   enableAdd={true}
    //   src={settings}
    // />
  }

  const viewerWrap = () => {
    return <div className={'hcs-container'}>
      <div className={'hcs-top'}>{pasteValue && viewer()}</div>
      <div className={'hcs-bottom'}>{jsonPaste()}</div>
    </div>
  }

  return viewerWrap()
}

export default JsonPasteSettings